// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-md + .item-inner ion-label {
  margin-left: 16px;
}

.item-checkbox .label {
  font-size: 1.5rem;
  color: #3D3D3D;
  font-weight: 400;
}

.ion-text-wrap {
  text-align: center;
}

.toggle {
  text-align-last: right;
}

.toggleText {
  align-content: space-evenly;
}

.picture-div {
  width: 100%;
  display: block;
  text-align-last: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/information-and-security/strong-authentication/strong-authentication.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;EACA,uBAAA;AACJ","sourcesContent":[".checkbox-md + .item-inner ion-label {\n    margin-left: 16px;\n}\n\n.item-checkbox .label {\n    font-size: 1.5rem;\n    color: #3D3D3D;\n    font-weight: 400;\n}\n\n.ion-text-wrap {\n    text-align: center;\n}\n\n.toggle {\n    text-align-last: right;\n}\n\n.toggleText {\n    align-content: space-evenly;\n}\n\n.picture-div {\n    width: 100%;\n    display: block;\n    text-align-last: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
